

import { defineComponent } from 'vue';

import { main } from '@popperjs/core';
import moment from 'moment';

export default defineComponent({
  name: "categories-card",
  props: {
    incidentes: {
        type: Array,
        default: () => {
          {};
        },
      }
    
  },
  methods: {

      gotoPedido(pedido:any){
        this.$router.push(`/pedidos/${pedido.id_pedido}`);
      },
  },
  setup(props:any) {
      
      const fDate = (date:any) => {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }

      return {
        fDate
      };
  }
});
